import { GD } from "src/GD";
import { hasRole } from "src/permissions";
import { banStatus } from "../../bans/banStatus";

export const sendBanMutation = async (request: IAPIRequest, userId: number, projectId: number, signal: AbortSignal) => {
	const [profile, project] = await Promise.all([GD.REQ_PROFILE.request(), GD.REQ_CURRENT_PROJECT.request()]);
	if (signal.aborted || profile?.id !== userId || project?.id !== projectId || !hasRole(profile?.projects.find(item => item.id === projectId)?.roles, "admin")) throw new Error("contextChanged");
	try { return await GD.REQ_API.request({ ...request, expectedProjectId: projectId, signal }); }
	finally { banStatus.invalidate({ projectId, userId }); }
};
